var exports = {
  "kL": "xa15a2ab7--25a2c9--container",
  "ur": "xa15a2ab7--25a2c9--container--disabled",
  "Qq": "xa15a2ab7--25a2c9--text",
};

module.exports = exports;
